import { connect } from 'react-redux';
import { callSelectors, conferenceRemoteModerationSelectors } from '@lifesize/nucleus';
import { openInCallModal } from 'actions/InCallModal';
import Header from 'components/Header/Header';
import Modals from 'constants/Modals';
import { isCallConnected } from 'utils/call-utils';

const mapDispatchToProps = (dispatch) => ({
  handleConfirmRemoteModerationEnd: () => {
    dispatch(openInCallModal(Modals.endRemoteModeration));
  }
});

const mapStateToProps = state => ({
  disabled: conferenceRemoteModerationSelectors.selectIsActive(state),
  isCallConnected: isCallConnected(callSelectors.activeCallSelector(state))
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
